/**
 * Types pour les paramètres du site (SiteSettings)
 */

export interface SiteSettings {
  id: number;
  siteName: string;
  siteTagline: string;
  logoUrl: string | null;
  faviconUrl: string | null;
  colorPrimary: string;
  colorPrimaryLight: string;
  colorPrimaryPale: string;
  colorBackground: string;
  colorSurface: string;
  colorText: string;
  colorTextLight: string;
  colorAccent1: string;
  colorAccent2: string;
  fontPrimary: string;
  fontHeading: string;
  fontMono: string;
  customCss: string | null;
  updatedAt: string;
}

/** Valeurs par défaut du thème anthracite/doré */
export const DEFAULT_SETTINGS: Omit<SiteSettings, 'id' | 'updatedAt'> = {
  siteName: 'Arketyp',
  siteTagline: 'Astrologie Humaniste Évolutive',
  logoUrl: null,
  faviconUrl: null,
  colorPrimary: '#c9a227',
  colorPrimaryLight: '#e0b83a',
  colorPrimaryPale: '#f5e6b3',
  colorBackground: '#fafafa',
  colorSurface: '#ffffff',
  colorText: '#333333',
  colorTextLight: '#666666',
  colorAccent1: '#1a1a1a',
  colorAccent2: '#2d2d2d',
  fontPrimary: 'Inter',
  fontHeading: 'Inter',
  fontMono: 'JetBrains Mono',
  customCss: null,
};
